import React from 'react';
//bootstrap
import { Col } from 'react-bootstrap';

//tremor
import { Flex, Subtitle, Title } from '@tremor/react';
//custome components
import { Card } from '_components/atoms';

// utils
import { Spacing } from '_styles';

// redux
import { useDispatch, useSelector } from 'react-redux';
import { selectMovementTimer, setMovementTimer } from '_redux/slices/timeline/timeline-control';

const TimelineScrollTimer = () => {

    const dispatch = useDispatch();

    const timer = useSelector(selectMovementTimer);

    const updateTimer = (time) => {
        let formattedTime = parseInt(time);
        dispatch(setMovementTimer(time));
    }

    return (
        <Col >
            <Card className="flex-fill" equalHeight={true}>
                <Title >Scroll timer</Title>
                <Subtitle style={{ fontWeight: "500" }}>
                    The number in seconds determine how frequently you want the time line employee list to auto scroll to the current time
                </Subtitle>
                <Flex>
                    <input
                        type="number"
                        style={{
                            fontSize: 14,
                            fontWeight: '400',
                            opacity: 1.0,
                            padding: Spacing.SCALE_8,
                            border: '1px solid lightgrey',
                            margin: 0
                        }}
                        placeholder={15}
                        onChange={(event) => { updateTimer(event.target.value) }}
                        value={timer}
                    />
                </Flex>
            </Card>
        </Col>

    );
};

export default TimelineScrollTimer;
